import { c as _c } from "react/compiler-runtime";
import { Dialog, DialogPanel, Transition, TransitionChild } from '@headlessui/react';
import { Fragment } from 'react';
interface IProps {
  isOpen: boolean;
  closeModal: () => void;
  component: any;
  isFull?: boolean;
  widthClass?: string;
  className?: string;
  id?: string;
}
export const Modal = t0 => {
  const $ = _c(12);
  const {
    isOpen,
    closeModal,
    component,
    isFull,
    widthClass,
    className,
    id
  } = t0;
  let width = isFull ? "min-w-[87.5%]" : "w-full";
  if (widthClass) {
    width = widthClass;
  }
  const t1 = isOpen || false;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <TransitionChild as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0" enterTo="opacity-100" leave="ease-in duration-200" leaveFrom="opacity-100" leaveTo="opacity-0"><div className="fixed inset-0 bg-gray-900/75 transition-opacity" /></TransitionChild>;
    t3 = <span className="hidden sm:inline-block sm:h-screen sm:align-middle" aria-hidden="true">​</span>;
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  const t4 = `relative z-10 ${width} my-8 inline-block rounded-xl bg-white text-left align-middle shadow-xl transition-all ${className}`;
  let t5;
  if ($[2] !== component || $[3] !== id || $[4] !== t4) {
    t5 = <div className="flex min-h-screen items-center justify-center px-2 pb-20 pt-4 text-center sm:block sm:p-0">{t2}{t3}<TransitionChild as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enterTo="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leaveFrom="opacity-100 translate-y-0 sm:scale-100" leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"><DialogPanel className={t4} id={id}>{component}</DialogPanel></TransitionChild></div>;
    $[2] = component;
    $[3] = id;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== closeModal || $[7] !== t5) {
    t6 = <Dialog as="div" className="fixed inset-0 z-[100] overflow-y-auto " onClose={closeModal}>{t5}</Dialog>;
    $[6] = closeModal;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t1 || $[10] !== t6) {
    t7 = <><Transition appear={true} show={t1} as={Fragment}>{t6}</Transition></>;
    $[9] = t1;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
};